import { z } from "zod"

export const PendingSubscribersTotalSchema = z
  .object({
    pendingRequestTotal: z.number(),
    pendingPaymentTotal: z.number(),
    allPending: z.number(),
  })
  .meta({ id: "PendingSubscribersTotalSchema" })

export type PendingSubscribersTotalDto = z.infer<typeof PendingSubscribersTotalSchema>
